import { render, staticRenderFns } from "./ComplianceRequirementsSection.vue?vue&type=template&id=13bb3999&scoped=true&"
import script from "./ComplianceRequirementsSection.vue?vue&type=script&lang=js&"
export * from "./ComplianceRequirementsSection.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceRequirementsSection.vue?vue&type=style&index=0&id=13bb3999&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bb3999",
  null
  
)

export default component.exports